import { Typography } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import { IconButton } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";

const SchemaListItems = ({ formData, onEdit, onDelete }) => {
  if (!formData) return null;

  return (
    <div className="container">
      <div className="answer">
        <h4 className="quest-header">Page Schema (JSON-LD)</h4>

        <pre
          style={{
            background: "#f5f5f5",
            padding: "12px",
            borderRadius: "6px",
            overflowX: "auto",
            fontSize: "13px",
          }}
        >
          {formData.schemaJson}
        </pre>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "flex-start",
            gap: "20px",
          }}
        >
          <EditIcon style={{ cursor: "pointer" }} onClick={onEdit} />

          <DeleteIcon onClick={onDelete} style={{ cursor: "pointer" }} />
        </div>
      </div>

      <div
        style={{
          width: "100%",
          background: "gray",
          height: "1px",
          marginTop: "30px",
        }}
      />
    </div>
  );
};

export default SchemaListItems;
